import { PublishedFormId } from '@furnish-hx/constants/FormId';
import FormTypeId from '@core/constants/FormTypeId';
import { WindowBlindsId } from '@core/constants/Shape';
import { FieldDimensionId } from '@core/constants/FieldDimension';
import { MaterialId } from '@core/constants/Material';
import { WindowBlindsOptionsId } from '@core/constants/Option';
import fieldPortfolioData from './common/fieldsPortfolioData';
import {
    IFormFieldKey,
    IForm,
    IFormInputType,
    IDimensionUnit,
} from '../../interfaces/Form';
import additionalDataFactory from './common/fieldsAdditionalData';
import fieldsContact from './common/fieldsContact';
import { allFabric, getMaterialsWithExceptions } from './common/materialGroups';

const windowBlindsOutdoorForm: IForm = {
    formId       : PublishedFormId.CustomBlindOutdoor,
    type         : FormTypeId.Blinds,
    thumbnailURL : '/resized-images/forms/windowBlindOutdoor.jpg',
    fieldsOrder  : [
        IFormFieldKey.PortfolioData,
        IFormFieldKey.Comment,
        IFormFieldKey.WindowBlindsDisposition,
        IFormFieldKey.WindowBlindsDwelling,
        IFormFieldKey.WindowBlindsStyle,
        IFormFieldKey.WindowBlindsDimension,
        IFormFieldKey.Material,
        IFormFieldKey.WindowBlindsProtection,
        IFormFieldKey.WindowBlindsManeuver,
        IFormFieldKey.WindowBlindsLight,
        IFormFieldKey.WindowBlindsPose,
        IFormFieldKey.AdditionalData,
        IFormFieldKey.Contact,
    ],
    fields: {
        portfolioData : fieldPortfolioData,
        comment       : {
            comment: {
                value    : undefined,
                required : false,
            },
        },
        windowBlindsDisposition: {
            value   : undefined,
            options : [
                WindowBlindsId.WindowBlindsBalcony,
                WindowBlindsId.WindowBlindsTerrace,
                WindowBlindsId.WindowBlindsWindow,
            ],
            required: true,
        },
        windowBlindsDwelling: {
            value   : undefined,
            options : [
                WindowBlindsId.WindowBlindsFlat,
                WindowBlindsId.WindowBlindsHouse,
            ],
            required: true,
        },
        windowBlindsStyle: {
            value   : undefined,
            options : [
                WindowBlindsId.WindowBlindsAwing,
                WindowBlindsId.WindowBlindsAwingProjection,
                WindowBlindsId.WindowBlindsDoubleAwing,
            ],
            required: true,
        },
        windowBlindsDimension: {
            [FieldDimensionId.Width]: {
                value        : undefined,
                type         : IFormInputType.Range,
                unit         : IDimensionUnit.Centimeters,
                step         : 100,
                range        : { min: 2000, max: 6000 },
                required     : true,
                defaultValue : 4000,
            },
            [FieldDimensionId.Depth]: {
                value        : undefined,
                type         : IFormInputType.Range,
                unit         : IDimensionUnit.Centimeters,
                step         : 100,
                range        : { min: 1000, max: 4000 },
                required     : true,
                defaultValue : 2000,
            },
            [FieldDimensionId.Height]: {
                value        : undefined,
                type         : IFormInputType.Range,
                unit         : IDimensionUnit.Centimeters,
                step         : 100,
                range        : { min: 2000, max: 4000 },
                required     : true,
                defaultValue : 2500,
            },
        },
        material: {
            material: {
                value   : undefined,
                options : getMaterialsWithExceptions(allFabric,
                    [
                        MaterialId.Fabric,
                    ]),
                required: true,
            },
        },
        windowBlindsProtection: {
            value   : undefined,
            options : [
                WindowBlindsOptionsId.IntegralChest,
                WindowBlindsOptionsId.SemiIntegralChest,
                WindowBlindsOptionsId.WithoutChest,
            ],
            required: true,
        },
        windowBlindsManeuver: {
            value   : undefined,
            options : [
                WindowBlindsOptionsId.MotorAndControl,
                WindowBlindsOptionsId.MotorAndSwitch,
                WindowBlindsOptionsId.Manual,
            ],
            required: true,
        },
        windowBlindsLight: {
            value: undefined,
        },
        windowBlindsPose: {
            value   : undefined,
            options : [
                WindowBlindsOptionsId.FrontOnWall,
                WindowBlindsOptionsId.UnderSlab,
                WindowBlindsOptionsId.Other,
            ],
            required: true,
        },
        additionalData: additionalDataFactory({
            budgetMin          : 500,
            budgetMax          : 6000,
            budgetDefaultValue : 2500,
        }),
        contact: fieldsContact,
    },
};

export default windowBlindsOutdoorForm;
